import {
    DEALERDSRMAPPINGLIST_FAILED,
    DEALERDSRMAPPINGLIST_SUCCESS,
    RESET_DEALERDSRMAPPINGLIST,
    LOADING_DEALERDSRMAPPINGLIST,
    NETWORK_ERROR_DEALERDSRMAPPINGLIST
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERDSRMAPPINGLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERDSRMAPPINGLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERDSRMAPPINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERDSRMAPPINGLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERDSRMAPPINGLIST:
            return (state = initialState);
        default:
            return state;
    }
};